export enum AspectRaioEnum {
    size_4_3 = 1.33,
    size_16_9 = 1.77
}
